export default __webpack_public_path__ + "static/media/metro-warning-orange.44a12177.svg";